import fetch from 'unfetch';

const searchUsers = async (query) => {
	const url = `/api/searchUsers`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({ query: query }),
	});

	if (res.ok) {
		console.log('here');
		console.log(await res.json());
		return { data: await res.json() };
	} else {
		return { status: 'error' };
	}
};
export default searchUsers;
